/**
 * 预约挂号相关路由
 */
export default [
  /**
   * 选择医院
   */
  {
    path: '/book/hos',
    meta: {
      title: '选择医院'
    },
    component: () => import('../pages/book/hos')
  },
  /**
   * 选择科室
   * query
   * **** hosId
   * **** hosName
   * **** type 0当天挂号 1预约挂号
   */
  {
    name: 'dept',
    path: '/book/dept',
    redirect: '/book/dept/dep',
    component: () => import('../pages/book/dept'),
    children: [
      {
        path: 'disease',
        name: 'jb',
        component: () => import('../pages/book/disease-list')
      },
      {
        path: 'college',
        name: 'zk',
        component: () => import('../pages/book/college-list')
      },
      {
        path: 'dep',
        name: 'ks',
        component: () => import('../pages/book/dept-list')
      }
    ]
  },
  /**
   * 选择医生
   * query
   * **** hosid
   * **** hosname
   * **** ksid
   * **** ksmc
   */
  {
    path: '/book/doct',
    component: () => import('../pages/book/doct'),
    children: [
      {
        path: 'date',
        component: () => import('../pages/book/doct/date')
      },
      {
        path: 'expert',
        component: () => import('../pages/book/doct/expert')
      }
    ]
  },
  /**
   * 选择医生
   * query
   * **** hosid
   * **** hosname
   * **** ksid
   * **** ksmc
   * **** ysid
   * cache
   * **** docArr
   */
  {
    path: '/book/paiban',
    component: () => import('../pages/book/paiban')
  },
  {
    path: '/book/check',
    component: () => import('../pages/book/check')
  },
  {
    path: '/book/succeed',
    component: () => import('../pages/book/succeed')
  }
]



// WEBPACK FOOTER //
// ./src/router/book.js